module.exports = __webpack_public_path__ + "img/logout.1e6458c2.svg";